import type { CreateLessonBody, LessonLocationVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

export enum LOCATION_TYPE {
  STUDIO = "STUDIO",
  ONLINE = "ONLINE",
  OTHER = "OTHER",
}

// Un coaching ne peut être déclaré que dans un studio référencé (fiche studio exigée par
// l'indicateur Qualiopi 17) ou en visio. `OTHER` reste dans l'énum pour relire les coachings
// historiques saisis en "Autre lieu", mais n'est plus déclarable.
export type DeclarableLocationType = LOCATION_TYPE.STUDIO | LOCATION_TYPE.ONLINE;

export const LocationLabelMap: Record<LOCATION_TYPE, string> = {
  [LOCATION_TYPE.STUDIO]: "Studio",
  [LOCATION_TYPE.OTHER]: "Autre lieu",
  [LOCATION_TYPE.ONLINE]: "Cours en visio",
};

export const getLocationName = ({ type, studio }: { type: LOCATION_TYPE; studio: { name: string } | null }): string => {
  if (type === LOCATION_TYPE.ONLINE) return LocationLabelMap[LOCATION_TYPE.ONLINE];
  if (type === LOCATION_TYPE.OTHER) return LocationLabelMap[LOCATION_TYPE.OTHER];
  if (type === LOCATION_TYPE.STUDIO && studio?.name) return studio.name;
  if (type === LOCATION_TYPE.STUDIO) return LocationLabelMap[LOCATION_TYPE.STUDIO];
  return "Inconnu";
};

export const teacherGetLocationName = (location: LessonLocationVM): string => {
  let name = getLocationName(location);

  // For STUDIO and OTHER types, check if paid by teacher
  const isPaidByTeacher = location.type === LOCATION_TYPE.OTHER || (location.type === LOCATION_TYPE.STUDIO && location.isPaidByTeacher);

  if (isPaidByTeacher && location.price > 0) {
    name += " (payé par prof.)";
  }
  return name;
};

export const getCreatedLessonPaidToTeacher = ({ hours, location }: CreateLessonBody): number => {
  const isPaidByTeacher = location.type === LOCATION_TYPE.STUDIO && location.isPaidByTeacher;
  return hours.quantity * (hours.hourlyPrice + (isPaidByTeacher ? location.price : 0));
};
